import TableSkeletonAccountPlatform from './tableSkeletonAccountPlatform';
import TableSkeletonHost from './tableSkeletonHost';
import TableSkeletonParameterByHost from './tableSkeletonParameterByHost';
import TableSkeletonSession from './tableSkeletonSession';

const TableSkeleton = ({ selectedTab }) => {
  switch (selectedTab) {
    case 'host':
      return <TableSkeletonHost />;

    case 'parameterByHost':
      return <TableSkeletonParameterByHost />;

    case 'session':
      return <TableSkeletonSession />;

    case 'accountPlatform':
      return <TableSkeletonAccountPlatform />;

    default:
      return <TableSkeletonHost />;
  }
};

export default TableSkeleton;
